
export const achost = window.API_HOST;
export const portal_name = window.PORTAL_NAME;
export const twitch_client_id = window.TWITCH_CLIENT_ID;
export const twitch_redirect_uri = window.TWITCH_REDIRECT_URI;
export const DEFAULT_HEADERS = {
    'X-Ava-Branch': 'default',
    'X-Ava-Project': 'acp',
    'X-Ava-Platform': 'portal'
}